import {
  Alert,
  Button,
  Center,
  Loader,
  Paper,
  PasswordInput,
  Stack,
  Text,
} from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";
import { useForm } from "@mantine/form";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import { acceptInvite, getInvite } from "@/api/auth";
import { notify } from "@/lib/notify";
import { PageTitle } from "@/components/PageTitle";

const MIN_LENGTH = 8;

// Davet bağlantısı. Oturum GEREKTİRMEZ — buraya gelen kişinin henüz şifresi bile yok.
export default function Invite() {
  const { token } = useParams();
  const navigate = useNavigate();
  // Panel'in her doğrulamalı formu useForm kullanıyor (AccountModal aynı iki kuralı taşıyor);
  // elle tutulan iki state + üç türetilmiş bayrak aynı işi daha fazla yerde yapıyordu.
  // validateInputOnChange: hata yazarken görünsün, gönderimi beklemesin.
  const form = useForm({
    validateInputOnChange: true,
    initialValues: { password: "", confirm: "" },
    validate: {
      password: (value) =>
        value.length >= MIN_LENGTH ? null : `En az ${MIN_LENGTH} karakter`,
      confirm: (value, values) =>
        value === values.password ? null : "Şifreler eşleşmiyor",
    },
  });

  const { data, isLoading, isError } = useQuery({
    queryKey: ["invite", token],
    queryFn: () => getInvite(token),
    // Geçersiz bir bağlantı tekrar denemekle geçerli olmuyor; sessiz yeniden denemeler
    // kullanıcıyı boş ekranda bekletiyordu.
    retry: false,
  });

  const mutation = useMutation({
    mutationFn: (values) => acceptInvite(token, values.password),
    onSuccess: () => {
      notify.success("Şifreniz belirlendi, giriş yapabilirsiniz");
      navigate("/login", { replace: true });
    },
    onError: (error) =>
      notify.error(
        error.response?.data?.error ??
          "Şifre belirlenemedi, bağlantıyı yeniden isteyin",
      ),
  });

  return (
    <Center
      mih="100vh"
      p="md"
      style={{
        background:
          "linear-gradient(135deg, var(--mantine-color-chocolate-0), var(--mantine-color-gray-1))",
      }}
    >
      <PageTitle>Şifre Belirle</PageTitle>
      <Paper withBorder shadow="md" radius="lg" p={32} w={420} maw="100%">
        <Stack align="center" gap={4} mb="lg">
          <img src="/noxus-emblem.svg" alt="Noxus" width={64} height={64} />
          <Text fw={700} size="xl" mt="sm">
            Şifrenizi belirleyin
          </Text>
        </Stack>

        {isLoading ? (
          <Center py="xl">
            <Loader size="sm" />
          </Center>
        ) : isError ? (
          // Geçersizliğin SEBEBİ yazılmıyor (yok / kullanılmış / süresi dolmuş): uç da
          // ayırmıyor, çünkü ayırmak bir token'ın var olup olmadığını denetmeye yarardı.
          <Stack>
            <Alert
              variant="light"
              color="red"
              icon={<IconAlertTriangle size={16} />}
            >
              <Text size="sm">
                Bu davet bağlantısı geçersiz veya süresi dolmuş. Sizi ekleyen
                kişiden yeni bir davet isteyin.
              </Text>
            </Alert>
            <Button
              variant="default"
              onClick={() => navigate("/login", { replace: true })}
            >
              Giriş ekranına dön
            </Button>
          </Stack>
        ) : (
          <form onSubmit={form.onSubmit((values) => mutation.mutate(values))}>
            <Stack>
              <Text size="sm" c="dimmed" ta="center">
                <b>{data.fullName}</b> olarak
                {data.tenantName
                  ? ` ${data.tenantName} paneline`
                  : " panele"}{" "}
                ekleniyorsunuz
                <br />
                {data.email}
              </Text>
              <PasswordInput
                label="Yeni şifre"
                autoComplete="new-password"
                placeholder={`En az ${MIN_LENGTH} karakter`}
                {...form.getInputProps("password")}
              />
              <PasswordInput
                label="Şifre tekrar"
                autoComplete="new-password"
                placeholder="••••••••"
                {...form.getInputProps("confirm")}
              />
              <Button fullWidth type="submit" loading={mutation.isPending}>
                Şifremi belirle
              </Button>
            </Stack>
          </form>
        )}
      </Paper>
    </Center>
  );
}
